export interface IFileView {
    file?: File;
    name: string;
    size: number;
    contentType: string;
    isRemote: boolean;
    downloadUrl?: string,
    downloadMethod: 'GET' | 'POST';
    deleteUrl?: string,
    deleteMethod: 'DELETE' | 'POST';
}

export class FileViewModel implements IFileView {

    file?: File;

    name: string = '';
    size: number = 0;
    contentType: string = '';
    isRemote: boolean = false;
    downloadUrl?: string;
    downloadMethod: 'GET' | 'POST' = 'GET';
    deleteUrl?: string;
    deleteMethod: 'DELETE' | 'POST' = 'DELETE';

    get FileName() { return this.name; }
    set FileName(val) { this.name = val; }

    get Size() { return this.size; }
    set Size(val) { this.size = val; }

    get ContentType() { return this.contentType; }
    set ContentType(val) { this.contentType = val; }


    constructor(options: File | Partial<IFileView>) {

        let input: Partial<IFileView>;

        if (options instanceof File) {
            let { name, size, type } = options;
            input = {
                file: options as File,
                name,
                size,
                contentType: type
            }
        }
        else
            input = { ...options };

        Object.assign(this, input)
    }

    /*
    constructor(
        public name: string,
        public size: number,
        public contentType: string,
        public isRemote: boolean = false,

        public file?: File,

        public downloadUrl?: string,
        public downloadMethod: 'GET' | 'POST' = 'GET',
        public deleteUrl?: string,
        public deleteMethod: 'DELETE' | 'POST' = 'DELETE',
    ) {}
        */
}
